import { Box } from '@mui/material'
import { FormField } from 'global/components/Form'

import { Documentos } from './Documentos'
import { Endereco } from './Endereco'
import { ParametrosDoCalculo } from './ParametrosDoCalculo'

export function DadosPessoaisForm({ editar }: { editar?: boolean }) {
    return (
        <Box component="section" id="dados">
            <Documentos />
            <Endereco />
            <ParametrosDoCalculo editar={editar} />
            <FormField name="empresaId" hidden />
        </Box>
    )
}
